import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/live-updates/live-updates.component').then(
        m => m.LiveUpdatesComponent,
      ),
  },
];
